// @flow

/*
 *  README:
 *  Mitigation/temporary solution to catch users attempting to view a
 *  non-anoymous cart while not being logged-in.
 *  Redirect these users to the LogIn page via `needsAuth`s `handleRedirect`.
 *  Let logged-in users, and anoymous users trying to view an anonymous cart
 *  pass through.
 */

import * as React from 'react';

import { Outlet } from 'react-router-dom';

import {
  selectIsAuthenticatedUser,
  handleNeedsAuthRedirect,
} from '@gandi/authentication';

import type { FetchResponse } from '@gandi/resource/redux';

import { GET } from 'gandi.redux-fetcher';

import type { Dispatch } from '../types';

const isCartAnonymous = (cartId: string) => (dispatch: Dispatch) =>
  dispatch(
    GET(`/cart/carts/${cartId}/anonymous`, {
      // explicitely override default `on401` handler, which would take
      // priority over `on4XX` handled if we defined one here.
      // $FlowFixMe[incompatible-exact]
      on401: (response: FetchResponse<401, any>) => Promise.reject(response),
      // handle other cases
      // $FlowFixMe[incompatible-exact]
      not401: (response: FetchResponse<any, any>) => {
        if (response.status === 403) {
          return Promise.reject(response);
        }

        return response;
      },
    }),
  );

export default class EnsureSSRLoggedInCartOwner extends React.Component<{}> {
  static async handleRedirect(args: any) {
    const {
      dispatch,
      getState,
      params: { cartId },
    } = args;
    if (!selectIsAuthenticatedUser(getState())) {
      try {
        await dispatch(isCartAnonymous(cartId));
      } catch (err) {
        await handleNeedsAuthRedirect(args);
      }
    }
  }

  render(): React.Node {
    return <Outlet />;
  }
}
